import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import './App.css';
import Header from './components/Header';
import Footer from './components/Footer';
import WhyChooseUs from './components/WhyChooseUs';
import CookieConsent from './components/CookieConsent';
import FloatingActions from './components/FloatingActions';
import ProtectedRoute from './components/ProtectedRoute';
import Home from './pages/Home';
import Products from './pages/Products';
import ProductDetail from './pages/ProductDetail';
import Cart from './pages/Cart';
import Checkout from './pages/Checkout';
import Account from './pages/Account';
import VendorApplication from './pages/VendorApplication';
import ImageRequirements from './pages/ImageRequirements';
import CookiePolicy from './pages/CookiePolicy';
import TermsConditions from './pages/TermsConditions';
import PrivacyPolicy from './pages/PrivacyPolicy';
import AdminLogin from './pages/AdminLogin';
import AdminResetPassword from './pages/AdminResetPassword';
import AdminDashboard from './pages/AdminDashboard';
import OrderConfirmation from './pages/OrderConfirmation';
import Cultures from './pages/Cultures';
import CultureDetail from './pages/CultureDetail';
import ShopperLogin from './pages/ShopperLogin';
import ShopperAccount from './pages/ShopperAccount';
import Favorites from './pages/Favorites';
import Shipping from './pages/Shipping';
import Quality from './pages/Quality';
import Payments from './pages/Payments';
import Returns from './pages/Returns';
import { CartProvider } from './context/CartContext';
import { AuthProvider } from './context/AuthContext';
import { FavoritesProvider } from './context/FavoritesContext';

function AppRoutes() {
  const location = useLocation();
  
  // Scroll to top when route changes
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return (
    <div className="App">
      <Header />
      <main style={{ minHeight: '80vh' }}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/products" element={<Products />} />
          <Route path="/products/:id" element={<ProductDetail />} />
          <Route path="/cart" element={<Cart />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/favorites" element={<Favorites />} />
          <Route path="/vendor-application" element={<VendorApplication />} />
          <Route path="/image-requirements" element={<ImageRequirements />} />
          <Route path="/cookie-policy" element={<CookiePolicy />} />
          <Route path="/terms-conditions" element={<TermsConditions />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/cultures" element={<Cultures />} />
          <Route path="/cultures/:cultureName" element={<CultureDetail />} />
          <Route path="/login" element={<ShopperLogin />} />
          <Route path="/shopper/account" element={<ShopperAccount />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/reset-password/:token" element={<AdminResetPassword />} />
          <Route path="/admin/dashboard/*" element={<AdminDashboard />} />
          <Route path="/admin/account" element={<ProtectedRoute element={<Account />} requiredRole="admin" />} />
          <Route path="/order-confirmation/:orderNumber" element={<OrderConfirmation />} />
          <Route path="/shipping" element={<Shipping />} />
          <Route path="/quality" element={<Quality />} />
          <Route path="/payments" element={<Payments />} />
          <Route path="/returns" element={<Returns />} />
        </Routes>
      </main>
      <WhyChooseUs />
      <Footer />
      <FloatingActions />
      <CookieConsent />
    </div>
  );
}

function App() {
  return (
    <Router>
      <AuthProvider>
        <CartProvider>
          <FavoritesProvider>
            <AppRoutes />
          </FavoritesProvider>
        </CartProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;
